export class DialogModelBillingOutstandingInvoice {
    constructor(
      public outstandingData: any
    ) {}
  }